/* eslint-disable @typescript-eslint/no-unused-vars */
import { useMediaQuery } from "@mui/material";
import { useScopelySignUp } from "hooks/useScopelySignUp";
import { BannerImage, Container, CustomButtom } from "./styles";
import { getVariantImage } from "helpers/getVariantImage";
import { LOCAL_STORAGE_LOGIN_FROM, useGoogleAnalyticsContext } from "contexts";
import nextButton from "assets/next-button.svg";
import { SignUpIncentiveResponse } from "interfaces/sign-up-incentive";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

const Banner = ({ data }: { data: SignUpIncentiveResponse }) => {
	const isPortrait = useMediaQuery("(max-width:1000px)");
	const {
		startLogin,
		logout,
		location,
		initiateLogin,
		isScopelyIdentityReady
	} = useScopelySignUp();
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();
	const isMegaMenuOpen = useSelector(
		(state: RootState) => state.megaMenu.isOpen
	);

	const handleClick = () => {
		if (!isScopelyIdentityReady) {
			return;
		}

		//logout();
		reportEvent("scopely_sign_up_incentive", {
			source: "mega_menu",
			action: "click"
		});
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "scopely_sign_up_incentive",
			event_type: "web_scopely_sign-up_incentive",
			action: "click",
			source: "mega_menu"
		});
		localStorage.setItem(LOCAL_STORAGE_LOGIN_FROM, "signup_incentive");
		//startLogin(location.pathname);
		initiateLogin(location.pathname);
	};

	useEffect(() => {
		if (isMegaMenuOpen) {
			reportEvent("scopely_sign_up_incentive", {
				source: "mega_menu",
				action: "show"
			});
			reportPlaygamiEvent("tp.web_frontend", {
				event_name: "scopely_sign_up_incentive",
				event_type: "web_scopely_sign-up_incentive",
				action: "show",
				source: "mega_menu"
			});
		}
	}, [isMegaMenuOpen]);

	return (
		<Container onClick={handleClick} $disabled={!isScopelyIdentityReady}>
			<BannerImage
				src={getVariantImage(
					data?.tracker?.megaMenuBannerImageUrl || "",
					"{incentive_rewards_variants}",
					isPortrait ? "small" : "large"
				)}
			/>
			<CustomButtom src={nextButton} />
		</Container>
	);
};

export default Banner;
